import { useEffect, useRef, useState, MutableRefObject } from 'react';

type UseRevealResult<T extends HTMLElement> = {
  ref: MutableRefObject<T | null>;
  inView: boolean;
};

export function useReveal<T extends HTMLElement>(threshold = 0.15): UseRevealResult<T> {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    if (typeof IntersectionObserver === `undefined`) {
      setInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, inView };
}
